<template>
	<div class="message">
		<div class="m-header" :style="showMain?'':'border-radius:5px'" @click.stop="changeShowMain(!showMain)">
			<span :class="['m-h-icon', showMain ? 'm-h-icon-active' : '']"></span>
			<span class="m-h-title">{{ title }}</span>
		</div>
		<div class="m-main" v-show="showMain" v-loading="loading">
			<div class="m-m-form">
				<div class="m-m-formItem" style="width: clamp(50%, 50%, 50%)">
					<div class="m-m-fi-label">课堂名称</div>
					<div class="m-m-fi-input">
						<el-input
							v-model="data.courseName"
							placeholder="请输入课堂名称"
							@change="changeData()"
						></el-input>
					</div>
				</div>

				<div class="m-m-formItem" style="width: clamp(21%,21%,21%)">
					<div class="m-m-fi-label">授课老师</div>
					<div class="m-m-fi-input">
						<el-input
							v-model="data.teacherName"
							placeholder="请输入授课老师"
							@change="changeData()"
						></el-input>
					</div>
				</div>

				<div class="m-m-formItem" style="width: clamp(22%,22%,22%)"">
					<div class="m-m-fi-label">授课时间</div>
					<div class="m-m-fi-input" style="position: relative;">
						<el-date-picker
							v-model="data.time"
							type="datetime"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width: 100%;"
							class="m_m_fi_inputDisabledIcon"
							prefix-icon="none"
							@change="changeData()"
							placeholder="请选择授课时间"
						>
						
						</el-date-picker>
						<i class="el-icon-date" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
					</div>
				</div>

				<div class="m-m-formItem" style="width: clamp(24%,24%,24%)"">
					<div class="m-m-fi-label">授课年级</div>
					<div class="m-m-fi-input">
						<el-select
							style="width: 100%"
							v-model="data.grade"
							@change="changeData()"
							placeholder="请选择年级"
						>
							<el-option
								v-for="(item, index) in gradeList"
								:key="index"
								:value="item.value"
								:label="item.label"
							></el-option>
						</el-select>
					</div>
				</div>

				<div class="m-m-formItem" style="width: clamp(24.5%,24.5%,24.5%)">
					<div class="m-m-fi-label">授课科目</div>
					<div class="m-m-fi-input">
						<el-select
							style="width: 100%"
							v-model="data.subject"
							@change="changeData()"
							placeholder="请选择科目"
						>
							<el-option
								v-for="(item, index) in subjectList"
								:key="index"
								:value="item.value"
								:label="item.label"
							></el-option>
						</el-select>
					</div>
				</div>

				<div class="m-m-formItem" style="width: clamp(21%,21%,21%)"">
					<div class="m-m-fi-label">教材版本</div>
					<div class="m-m-fi-input">
						<el-input
							v-model="data.textbook"
							placeholder="请输入教材版本"
							@change="changeData()"
						></el-input>
					</div>
				</div>

				<div class="m-m-formItem" style="width: clamp(22%,22%,22%)"">
					<div class="m-m-fi-label">学生人数</div>
					<div class="m-m-fi-input">
						<el-input
							v-model.number="data.studentNum"
							placeholder="请输入学生人数"
							@change="changeData()"
						></el-input>
					</div>
				</div>
			</div>
			<div class="fileList">
				<div class="fl_img">
					<div class="imgTit">
						<span>课堂图片</span>
						<span>（建议图片比例16:9，最多上传3张）</span>
					</div>
					<div class="m-m-formImage" v-loading="uploadImageLoading">
								<div
									class="m-m-fi-imageItem"
									v-for="(value, key, index) in imageList"
									:key="index"
									v-if="(key == 'fileList1' || key == 'fileList2' || key == 'fileList3') && value.length >0"
									@click.stop="previewImg(value[0].url)"
									style="max-width:32%;"
								>
									<el-image
										class="itemUrl"
										:src="value[0].url"
										fit="cover"
										style="width: 100%;"
									></el-image>
									<span @click.stop="delImage(key)"></span>
									<!-- <img class="itemUrl" :src="value[0].url" alt="" /> -->
								</div>
								<!-- 图片区域 -->

							<div
								class="m-m-fi-imageItem"
								@click.stop="addImage()"
								style="max-width:32%;"
								v-if="
									imageList.fileList1 &&
									imageList.fileList1.length +
										imageList.fileList2.length +
										imageList.fileList3.length <
										3
								"
							>
								<img
									src="../../../../assets/icon/classroomObservation/Union.svg"
									alt=""
								/>
								<div
									style="
										font-size: 12px;
										font-weight: 400;
										margin-top: 5px;
										color: rgba(0, 0, 0, 0.4);
									"
								>
									点击上传图片
								</div>
							</div>
							<!-- 图片区域 -->
						<!-- <div class="m-m-fi-btn" >添加课堂图片</div> -->
					</div>
				</div>
				<div class="fl_video">
					<div class="imgTit">
						<span>课堂视频</span>
						<span></span>
						<!-- <span>（建议视频比例16:9，最多上传1个）</span> -->
					</div>
  
					<div class="m-m-formImage" v-loading="uploadVideoLoading">
						
								<div
									class="m-m-fi-imageItem"
									style="max-width:100%;"
									v-if="!imageList.videoList.length==0"
									v-for="(item, index) in imageList.videoList?imageList.videoList:[]"
									:key="index"
									@click.stop="previewVideo(item.url)"
								>
								<!-- <div>{{ item }}</div> -->
									<el-image
										class="itemUrl"
										:src="require('../../../../assets/icon/classroomObservation/isVideo.png')"
										fit="cover"
									></el-image>
									<span @click.stop="delVideo('videoList')"></span>
								</div>
							<!-- <el-progress v-if="progressData.uploadVideo && !imageList.videoList.length" class="m_m_fi_progress" :percentage="progressData.value"></el-progress> -->
							<el-popover
  					  placement="top"
  					  width="180"
  					  trigger="hover"
							style="width: 140px"
							:disabled="!tid"
							v-if="(((imageList.videoList&&imageList.videoList.length<=0) || !imageList.videoList) && !progressData.uploadVideo)"
  					>
						<div class="m_m_box">
							<el-button-group style="width: 100%;display: flex;justify-content: center;">
							  <el-button size="small" @click="localUploadVideo()">本地上传</el-button>
								<el-button size="small" @click="resourceUploadVideo()">资源库上传</el-button>
							</el-button-group>
						</div>
							<div
							  slot="reference"
								class="m-m-fi-imageItem"
								@click.stop="addVideo()"
								style="max-width:100%;"
								v-if="(((imageList.videoList&&imageList.videoList.length<=0) || !imageList.videoList) && !progressData.uploadVideo)"
							>
								<img
									src="../../../../assets/icon/classroomObservation/Union.svg"
									alt=""
								/>
								<div
									style="
										font-size: 12px;
										font-weight: 400;
										margin-top: 5px;
										color: rgba(0, 0, 0, 0.4);
									"
								>
									点击上传视频
								</div>
							</div>
						</el-popover>

							<div
								class="m-m-fi-imageItem"
								style="max-width:60%;border-radius: 8px;overflow: hidden;"
								v-if="progressData.uploadVideo && !imageList.videoList.length""
							>
							<el-image
								class="itemUrl"
								:src="require('../../../../assets/icon/classroomObservation/videoFile.svg')"
								fit="cover"
							></el-image>
							<div class="m_m_fi_videBtn">
								<img v-if="!progressData.stop" :src="require('../../../../assets/icon/classroomObservation/stopIcon.png')" @click.stop="stopUploadVideo()">
								<img v-if="progressData.stop" :src="require('../../../../assets/icon/classroomObservation/startIcon.png')"  @click.stop="startUploadVideo()">
								<img :src="require('../../../../assets/icon/classroomObservation/delFile.svg')" @click.stop="delUploadVideo()">
							</div>
							<div class="m_m_fi_progress">
									<div>{{ progressData.value }}%</div>
									<span v-if="!progressData.stop">上传中...</span>
									<span v-else>已暂停</span>
									<div class="m_m_fi_p_bar">
										<div :style="{width:progressData.value+'%'}"></div>
									</div>
							</div>
						</div>
						<!-- <div class="m-m-fi-btn" >添加课堂图片</div> -->
					</div>
				</div>
				<!-- <div class="nephogramArea"> -->
				<div class="fl_nephogram">
					<div class="imgTit">
						<span>词云图</span>
						<span></span>
					</div>
					<div class="m-m-formImage">
								<div
									class="m-m-fi-nephogramItem"
									style="width:100%;"
									 v-loading="uploadNephogramLoading"
									v-if="(imageList.NephogramList&&imageList.NephogramList.length>0)"
								>
									<wordcloudEChart :data="imageList.NephogramList[0]"/>
									<span @click.stop="delNephogram('NephogramList')"></span>
								</div>
							<div
								class="m-m-fi-nephogramItem"
								 v-loading="uploadNephogramLoading"
								@click.stop="addNephogram()"
								style="width:60%;max-height: 100px;"
								v-if="((imageList.NephogramList&&imageList.NephogramList.length<=0) || !imageList.NephogramList)"
							>
								<img
									:src="require('../../../../assets/icon/classroomObservation/bmRefresh.png')"
									alt=""
									style="width:20px"
								/>
								<div
									style="
										font-size: 12px;
										font-weight: 400;
										margin-top: 5px;
										color: rgba(0, 0, 0, 0.4);
									"
								>
									生成词云图
								</div>
							</div>
					</div>
				<!-- </div> -->
			</div>
				
			</div>
			
		</div>
		<!-- <el-button @click="testFFmpeg">testFFmpeg</el-button> -->
		<previewVideoDialog ref="previewVideoDialogRef" />
		<uploadFile v-if="progressData.uploadVideo" ref="uploadFileRef" @progressUpdate="videoProgressUpdate" @delUpload="videoDelUpload" @success="updateVideoSuccess" @startUpload="videoStartUpload"/>
		<resourceLibraryDialog ref="resourceLibraryDialogRef" @addFile="resourceLibraryDialogAddFile"/>
		<!-- <iframe ref="iframeFFmpegRef" allow="camera *; microphone *;display-capture;midi;encrypted-media;" src="https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/static/cocoroboffmpeg/index.html" v-show="false"></iframe>https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/cocoroboffmpeg  http://localhost:8080/#/cocoroboffmpeg -->
	</div>
</template>

<script>
import previewVideoDialog from './previewVideoDialog.vue';
import wordcloudEChart from './wordcloudEChart.vue'
import uploadFile from './uploadFile.vue';
import { v4 as uuidv4 } from "uuid";
import resourceLibraryDialog from './resourceLibraryDialog.vue';

const getFile = (url) => {
  return new Promise((resolve, reject) => {
    var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
      let url2 = url;
      let _url2 = "";
      if (
        url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
      ) {
        _url2 = url2.split(
          "https://view.officeapps.live.com/op/view.aspx?src="
        )[1];
      } else {
        _url2 = url2;
      }
      var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
      let name = decodeURIComponent(_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1])
      var params = {
        Bucket: "ccrb",
        Key: name
      };
      s3.getObject(params, function (err, data) {
        if (err) {
          console.log(err, err.stack)
          resolve({ data: 1 });
        }else {
          resolve({ data: data.Body });
          console.log(data); 
        }          // sxuccessful response

      });
  });
};
export default {
	emits: ["saveData", "saveImage", "saveVideo","delImage","saveNephogram"],
	components:{
		previewVideoDialog,
		wordcloudEChart,
		uploadFile,
		resourceLibraryDialog
	},
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			},
		},
		tid:{
			type:String,
			default:"",
		},
		imageList: {
			type: Object,
			default: () => {
				return {
					fileList:[],
					fileList1:[],
					fileList2:[],
					fileList3:[],
					videoList:[],
				};
			},
		},
		dataList:{
			type:Array,
			default:()=>[]
		}
	},
	data() {
		return {
			title: "基本信息",
			chartObj:null,
			showMain: true,
			uploadImageLoading: false,
			uploadVideoLoading:false,
			uploadNephogramLoading:false,
			from: {
				courseName: "",
				teacherName: "",
				grade: "",
				subject: "",
				class: "",
				studentNum: 0,
			},
			gradeList: [
				{ value: "小学一年级", label: "小学一年级" },
				{ value: "小学二年级", label: "小学二年级" },
				{ value: "小学三年级", label: "小学三年级" },
				{ value: "小学四年级", label: "小学四年级" },
				{ value: "小学五年级", label: "小学五年级" },
				{ value: "小学六年级", label: "小学六年级" },
				{ value: "初中一年级", label: "初中一年级" },
				{ value: "初中二年级", label: "初中二年级" },
				{ value: "初中三年级", label: "初中三年级" },
				{ value: "高中一年级", label: "高中一年级" },
				{ value: "高中二年级", label: "高中二年级" },
				{ value: "高中三年级", label: "高中三年级" },
			],
			subjectList: [
				{ value: "语文", label: "语文" },
				{ value: "数学", label: "数学" },
				{ value: "英语", label: "英语" },
				{ value: "科学", label: "科学" },
				{ value: "信息技术", label: "信息技术" },
				{ value: "心理", label: "心理" },
				{ value: "物理", label: "物理" },
				{ value: "化学", label: "化学" },
				{ value: "生物", label: "生物" },
				{ value: "历史", label: "历史" },
				{ value: "地理", label: "地理" },
				{ value: "通用技术", label: "通用技术" },
				{ value: "政治", label: "政治" },
				{ value: "STEM", label: "STEM" },
				{ value: "美术", label: "美术" },
				{ value: "音乐", label: "音乐" },
				{ value: "其他", label: "其他" },
			],
			progressData:{
				stop:false,
				uploadVideo:false,
				value:0,
				status:"",
				key:"",
				uploadid:"",
			},
			uploadFileObj:null,
			loading:false,
		};
	},
	watch:{
		imageList(){
			this.$forceUpdate();
			this.progressData.uploadVideo = false;
		}
	},
	methods: {
		// 添加图片
		addImage() {
			if(!this.tid)return this.$message.error("请选择课堂")
			// 上传录音
			let input = document.createElement("input");
			input.type = "file";
			input.accept = "image/*";
			input.click();
			input.onchange = () => {
				this.uploadImageLoading = true;
				let file = input.files[0];
				var credentials = {
					accessKeyId: "AKIATLPEDU37QV5CHLMH",
					secretAccessKey: "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",
				}; //秘钥形式的登录上传
				window.AWS.config.update(credentials);
				window.AWS.config.region = "cn-northwest-1"; //设置区域

				var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
				var _this = this;

				if (file) {
					var params = {
						Key:
							file.name.split(".")[0] +
							new Date().getTime() +
							"." +
							file.name.split(".")[file.name.split(".").length - 1],
						ContentType: file.type,
						Body: file,
						"Access-Control-Allow-Credentials": "*",
						ACL: "public-read",
					}; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
					var options = {
						partSize: 2048 * 1024 * 1024,
						queueSize: 2,
						leavePartsOnError: true,
					};
					bucket
						.upload(params, options)
						.on("httpUploadProgress", function (evt) {
							//这里可以写进度条
							// console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
						})
						.send(function (err, data) {
							if (err) {
								_this.$message.error("上传失败");
							} else {
								_this.$emit("saveImage", {
									name: data.key,
									status: "success",
									uid: "1",
									url: data.Location,
								});
								// _this.from.audioUrl = data.Location;
								// _this.from.audioName = file.name;
								// _this.from.audioSize = file.size;
								// _this.from.audioTime = file.lastModified;

								// console.log(data.Location)
							}
							_this.uploadImageLoading = false;
						});
				}
			};
			// this.mainBtnStatus = 1;
			// this.barNum = 4;
		},
		// 添加视频
		addVideo(){
			if(!this.tid)return this.$message.error("请选择课堂")
			let input = document.createElement("input");
			input.type = "file";
			input.accept = "video/*";
			input.click();
			input.onchange = () => {
				this.progressData.uploadVideo = true;
				// this.uploadVideoLoading = true;
				this.progressData.stop = false;
				this.progressData.status = "";
				this.progressData.value = 0;
				let file = input.files[0];
				this.uploadFileObj = file;
				this.$nextTick(()=>{
					this.$refs.uploadFileRef.awsupload({
					file:file,
					folderName:this.tid
				})
				})
			}
			// 	this.progressData.uploadVideo = true;
			// 	// this.uploadVideoLoading = true;
			// 	this.progressData.stop = false;
			// 	let file = input.files[0];
			// 	var credentials = {
			// 		accessKeyId: "AKIATLPEDU37QV5CHLMH",
			// 		secretAccessKey: "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",
			// 	}; //秘钥形式的登录上传
			// 	window.AWS.config.update(credentials);
			// 	window.AWS.config.region = "cn-northwest-1"; //设置区域

			// 	var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
			// 	var _this = this;

			// 	if (file) {
			// 		var params = {
			// 			Key:
			// 				file.name.split(".")[0] +
			// 				new Date().getTime() +
			// 				"." +
			// 				file.name.split(".")[file.name.split(".").length - 1],
			// 			ContentType: file.type,
			// 			Body: file,
			// 			"Access-Control-Allow-Credentials": "*",
			// 			ACL: "public-read",
			// 		}; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
			// 		var options = {
			// 			partSize: 2048 * 1024 * 1024,
			// 			queueSize: 2,
			// 			leavePartsOnError: true,
			// 		};
					
			// 		bucket
			// 			.upload(params, options)
			// 			.on("httpUploadProgress", function (evt) {
			// 				//这里可以写进度条
			// 				// console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
			// 				_this.progressData.value = parseInt((evt.loaded * 100) / evt.total)
			// 			})
			// 			.send(function (err, data) {
			// 				if (err) {
			// 					_this.$message.error("上传失败");
			// 				} else {
			// 					_this.$emit('saveVideo',{
			// 							name: data.key,
			// 							status: "success",
			// 							uid: "1",
			// 							url: data.Location,
			// 					})
			// 				}
			// 				_this.progressData.uploadVideo = false;
			// 				_this.progressData.value = 0;
			// 				_this.progressData.stop = false;
			// 				// _this.uploadVideoLoading = false;
			// 			});
			// 	}
			// };
		},
		videoStartUpload({key,uploadid}){
			this.progressData.uploadid = uploadid;
			this.progressData.key = key;
			this.progressData.status = "start"
		},
		updateVideoSuccess(res){
			if(!res.data)return;
			this.progressData.uploadVideo = false;
			this.progressData.stop = false;
			this.progressData.uploadid = "";
			this.progressData.status = "";
			this.progressData.value = 0;
			let {data} = res;
			this.$refs.uploadFileRef.file = null;
			this.$emit('saveVideo',{
					name: data.Key,
					status: "success",
					uid: "qgt",
					url: data.Location,
			})
			this.$message.success("上传成功");
			// this.uploadFileObj = null;
			this.$confirm("是否提取视频音频并上传？","提示").then(()=>{
				this.getVideoVoice({file:this.uploadFileObj});
				this.uploadFileObj = null;
			}).catch(err=>{
				this.uploadFileObj = null;
			})
		},
		videoProgressUpdate(data){
			if(data.status=="processing"){
				this.progressData.value = data.percent;
				this.progressData.status = data.status;
			}else if(data.status=="fail"){
				this.progressData.value = data.percent;
				this.progressData.status = data.status;
				this.$message.error('上传发生错误，请点击继续上传')
				this.$refs.uploadFileRef.stopUpload();
			}else if(data.status=="success"){
				this.progressData.value = data.percent;
				this.progressData.status = data.status;
				this.$refs.uploadFileRef.stopUpload();
			}else if(data.status=="error"){
				this.progressData.stop = true;
				this.progressData.status = data.status;
				this.$refs.uploadFileRef.stopUpload();
				this.$message.error('上传发生错误，请重新上传')
			}
			console.log(this.progressData)
		},
		videoDelUpload(res){
			this.progressData.uploadVideo = false;
			this.progressData.uploadid = "";
			this.progressData.key = "";
			this.progressData.status = "";
			this.progressData.stop = false;
			this.progressData.value = 0;
			this.$message.success("已删除视频");
		},
		//添加云图
		addNephogram(){
			if(!this.tid)return this.$message.error("请选择课堂")
			if(this.uploadNephogramLoading)return this.$message.info("请稍等");
			this.uploadNephogramLoading = true;
			const _msg = `NOTICE
Language: Please use the same language as the user requirement, if the user speaks Chinese, the specific text of your answer should also be in Chinese.
ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced "Format example".
Instruction: Based on the context, follow "Format example", write content.

## 任务

请基于以下课堂实录文本（大约5000字），提炼出20-30个关键词，用于绘制词云图。请给出相应的关键词，关键词出现的频次，词云图上的大小。请确保输出的关键字准确反映课堂实录的主要内容和主题。

## 要求

1. **提取关键词**：从提供的课堂实录文本中提取出20-30个最具代表性的关键字。关键词应该涵盖课堂实录中的主要概念、重要术语和核心主题。尽量选择多样化的关键词，避免过于集中在某一个主题或概念上。
2. **词频统计**：计算每个关键字在文本中出现的频率。
3. **词汇大小**：根据词频数量，确定每个关键字在词云图中的大小。词频越高，词汇大小数值越大，数值范围1-100。
4. **输出格式**：输出结果应包含每个关键字、对应的词频数量以及词汇大小数值。

## 输出格式

### 输出格式

[
	{"value":1,"name":"氯化钠","textStyle":{"color":"#ee7959"}},
	{"value":2,"name":"溶液","textStyle":{"color":"#db9b34"}},
	{"value":1,"name":"实验","textStyle":{"color":"#9d9d82"}},
	{"value":3,"name":"质量分数","textStyle":{"color":"#ea5514"}},
	{"value":1,"name":"溶质","textStyle":{"color":"#c8161d"}},
	{"value":2,"name":"氢氧化钠","textStyle":{"color":"#e60012"}},
	{"value":1,"name":"溶解度","textStyle":{"color":"#1e2732"}},
	{"value":4,"name":"饱和溶液","textStyle":{"color":"#e3adb9"}}
]

请仅仅输出表头，输出关键词和相应的内容，无需其它任何说明文字。
冒号、逗号等符号均使用英文字符。

### 输出示例

[
	{"value":1,"name":"氯化钠","textStyle":{"color":"#ee7959"}},
	{"value":2,"name":"溶液","textStyle":{"color":"#db9b34"}},
	{"value":1,"name":"实验","textStyle":{"color":"#9d9d82"}},
	{"value":3,"name":"质量分数","textStyle":{"color":"#ea5514"}},
	{"value":1,"name":"溶质","textStyle":{"color":"#c8161d"}},
	{"value":2,"name":"氢氧化钠","textStyle":{"color":"#e60012"}},
	{"value":1,"name":"溶解度","textStyle":{"color":"#1e2732"}},
	{"value":4,"name":"饱和溶液","textStyle":{"color":"#e3adb9"}}
]

## 课堂实录 
${this.data.editorBarData?this.data.editorBarData.content:""}
`;			
				const _uuid = uuidv4();
				let params = {
					model: "gpt-3.5-turbo",
					temperature: 0,
					max_tokens: 4096,
					top_p: 1,
					frequency_penalty: 0,
					presence_penalty: 0,
					messages: [{ role: "user", content: _msg }],
					uid: _uuid,
					mind_map_question: "",
					stream: false,
					model: "gpt-4o-2024-11-20",
				};
				this.ajax
					.post("https://gpt4.cocorobo.cn/chat", params)
					.then((res) => {
						let _data = res.data.FunctionResponse.choices[0];
						let _jsonData = _data.message.content;
						_jsonData = _jsonData.replaceAll("```json", "").replaceAll("```", "");
						let _result = JSON.parse(_jsonData);
						console.log(_jsonData)
						this.$emit('saveNephogram',{
    tooltip: {
      show: false,
    },
    series: [
      {
        type: 'wordCloud',
        sizeRange: [14, 38],
        rotationRange: [0, 0],
				keepAspect:false,
				shape: 'circle',
        left: 'center',
        top: 'center',
        right: null,
        bottom: null,
        width: '90%',
        height: '90%',
        // maskImage: maskImage,
				// sizeRange: [12, 60],
				rotationRange: [-90, 90],
        rotationStep: 45,
        // gridSize: 12,
        // autoSize: {
        //   enable: true,
        //   minSize: 12,
        // },
        data: _result,
      },
    ],
  })
					})
					.catch((e) => {
						console.log(e);
						this.$message.error("生成词云图失败");
						this.uploadNephogramLoading = false;
					})
					.finally((_) => {
						this.uploadNephogramLoading = false;
					});
		},

		// 删除图片
		delImage(key) {
			this.$confirm("确定删除该图片吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$emit("delImage", key);
			});
		},
		// 删除视频
		delVideo(key){
			this.$confirm("确定删除该视频吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$emit("delImage", key);
			}).catch(e=>{
				console.log("取消删除")
			});
		},
		//删除词云图
		delNephogram(key){
			this.$confirm("确定删除该词云图吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$emit("delImage", key);
			}).catch(e=>{
				console.log("取消删除")
			});
		},
		changeShowMain(newValue) {
			this.showMain = newValue;
		},
		previewImg(url) {
			this.$hevueImgPreview(url);
		},
		previewVideo(url){
			this.$refs.previewVideoDialogRef.open(url)
			// this.$message.info(`预览:${url}`)
		},
		changeData() {
			if(!this.tid)return this.$message.error("请选择课堂")
			this.$emit("saveData");
		},
		// 停止上传视频
		stopUploadVideo(){
			this.$refs.uploadFileRef.stopUpload();
			this.progressData.stop = true;
			this.$message.success("已停止上传")
		},
		//开始上传视频
		startUploadVideo(){
			// this.$message.info("开始上传")
			if(this.$refs.uploadFileRef.file && this.progressData.key){
				this.$refs.uploadFileRef.awsupload({keyName:this.progressData.key})
			}else{
				this.addVideo();
			}
			this.progressData.stop = false;
		},
		delUploadVideo(){
			this.$refs.uploadFileRef.stopUpload();
			this.$refs.uploadFileRef.abortMultipartUpload(this.progressData.key,this.progressData.uploadid);
		},
		localUploadVideo(){
			this.addVideo();
		},
		resourceUploadVideo(){
			this.$refs.resourceLibraryDialogRef.open();
		},
		resourceLibraryDialogAddFile(file){
			let _file = file[0];
			if(!_file.file.endsWith(".mp4")){
				this.$message.error("请选择mp4视频文件")
				return;
			}
			this.$emit('saveVideo',{
					name: _file.name,
					status: "success",
					uid: _file.id,
					url: _file.file,
			})
			this.$message.success("上传成功")

			this.$confirm("是否提取视频音频并上传？","提示").then(()=>{
				this.getVideoVoice({url:_file.file});
			})
		},
		async getVideoVoice(obj){
			if(this.loading)return this.$message.info("请稍等");
			this.loading = true;
			let _file = null;
			if(obj.url){
				let res = await getFile(obj.url);
				if(res.data===1){
					this.loading = false;
					return this.$message.error("文件不存在")
				}

				// 把uint8Array转换为视频文件
				_file = new File([res.data], 'video.mp4', { type: 'video/mp4' });

			}else{
				_file = obj.file;
			}


			if (!_file) return this.$message.error("文件不存在");

			try {
				const reader = new FileReader();
				reader.onload = async (e) =>{
					// 创建音频上下文
					const audioContext = new (window.AudioContext || window.webkitAudioContext)();

					//解码音频数据
					const buffer = await audioContext.decodeAudioData(e.target.result);

					//创建离线音频上下文
					const offlineAudioContext = new OfflineAudioContext({numberOfChannels:buffer.numberOfChannels,length:buffer.length,sampleRate:buffer.sampleRate});

					//创建音源节点
					const source = offlineAudioContext.createBufferSource();
					source.buffer = buffer;
					source.connect(offlineAudioContext.destination);
					source.start();

					//渲染音频
					const renderedBuffer = await offlineAudioContext.startRendering();
					const wavBlob = this.bufferToWav(renderedBuffer);

					// blob转成file文件
					const audioFile = new File([wavBlob], 'audio.wav', { type: 'audio/wav' });

					// console.log(wavBlob)

					this.$emit("getVideoAudioSuccess",audioFile)
					this.$message.success("提取音频成功")
					this.loading = false;
				}
				reader.readAsArrayBuffer(_file);
			} catch (error) {
				console.log(error);
				this.$message.error("提取音频失败")
				this.loading = false;
			}

		},
		bufferToWav(audioBuffer) {
        const numOfChan = audioBuffer.numberOfChannels;
        const length = audioBuffer.length * numOfChan * 2;
        const buffer = new ArrayBuffer(44 + length);
        const view = new DataView(buffer);
        const channels = [];
        let pos = 0;
        // 获取通道数据
        for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
            channels.push(audioBuffer.getChannelData(i));
        }
        // 写入WAV头
        this.writeUTFBytes(view, 0, 'RIFF');
        view.setUint32(4, 44 + length - 8, true);
        this.writeUTFBytes(view, 8, 'WAVE');
        this.writeUTFBytes(view, 12, 'fmt ');
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numOfChan, true);
        view.setUint32(24, audioBuffer.sampleRate, true);
        view.setUint32(28, audioBuffer.sampleRate * 2 * numOfChan, true);
        view.setUint16(32, numOfChan * 2, true);
        view.setUint16(34, 16, true);
        this.writeUTFBytes(view, 36, 'data');
        view.setUint32(40, length, true);
        // 写入PCM数据
        pos = 44;
        for (let i = 0; i < audioBuffer.length; i++) {
            for (let j = 0; j < numOfChan; j++) {
                const sample = Math.max(-1, Math.min(1, channels[j][i]));
                view.setInt16(pos, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
                pos += 2;
            }
        }
        return new Blob([buffer], { type: 'audio/wav' });
    },
		writeUTFBytes(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
            view.setUint8(offset + i, string.charCodeAt(i));
        }
    }
	},
	mounted() {
		window.addEventListener('message',(e)=>{
			let _data = e.data;
			if(_data.code === 0){
				this.$message.success(_data.msg);
				this.loading = false;
				this.$emit("getVideoAudioSuccess",_data.file)
			}else if(_data.code === 1){
				this.$message.error(_data.msg);
				this.loading = false;
			}
		})
		// this.showNephogram();
	},
};
</script>

<style scoped>
.message {
	width: 100%;
	height: auto;
	/* background-color: red; */
}
.imgTit {
	height: 40px;
	line-height: 40px;
}
.imgTit :first-child {
	font-size: 16px;
	font-weight: 400;
	line-height: 22px;
	text-align: right;
}
.imgTit :last-child {
	font-family: PingFang SC;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	text-align: left;
	color: rgba(0, 0, 0, 0.4);
}
.baseInfoLeft {
	display: flex;
	width: 70%;
	flex-direction: column;
	/* justify-content: space-between; */
	margin-right: 10px;
}
.baseInfoLeft >>> .baseInfoLeftBot {
	display: flex;
	justify-content: space-between;
	margin: 10px 0;
}
.m-m-formItemBot {
	width: 30%;
	/* height: auto; */
	/* display: flex; */
	/* flex-direction: column; */
	/* align-items: left; */
	/* margin-bottom: 20px; */
}
.baseInfoRight {
	display: flex;
	flex: 1;
	flex-direction: column;
	/* justify-content: space-between; */
}

.m-header {
	width: calc(100% - 10px);
	height: 60px;
	display: flex;
	align-items: center;
	cursor: pointer;
	border-radius: 5px 5px 0 0;
	box-sizing: border-box;
	padding: 0 10px;
	background-color: #F8F9FA;
}

.m-h-icon {
	width: 18px;
	height: 18px;
	background: url("../../../../assets/icon/classroomObservation/right.svg")
		no-repeat;
	background-size: 100% 100%;
	margin-right: 5px;
	transition: 0.3s;
}

.m-h-icon-active {
	transform: rotate(90deg);
}

.m-h-title {
	font-size: 18px;
	font-weight: bold;
}

.m-main {
	width: calc(100% - 10px);
	height: auto;
	border-radius:0 0 5px 5px;
	background-color: #ffffff;
	padding: 20px 20px 0 20px;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
}

.m-m-form {
	display: flex;
	flex-wrap: wrap;
	width: 100%;

}

.m-m-formItem {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: left;
	margin-top: 10px;
	margin-right: 1.5%;
	/* margin-bottom: 10px; */
}

.m-m-fi-input {
	max-width: 100%;
}

.m_m_fi_inputDisabledIcon>>> .el-input__prefix{
	display: none;
}

.m_m_fi_inputDisabledIcon>>>.el-input__inner{
	padding-left: 15px;
}

.m-m-fi-label {
	font-size: 16px;
	display: flex;
	padding-bottom: 5px;
	/* justify-content: center; */
	/* align-items: center; */
	box-sizing: border-box;
	/* padding: 0 10px; */
	text-wrap: nowrap;
	min-width: fit-content;
}

.m-m-formImage {
	width: 100%;
	height: auto;
	margin-bottom: 20px;
	display: flex;
	justify-content: flex-start;
	/* flex-wrap: wrap; */
}

.m-m-fi-imageList {
	width: 100%;
	height: auto;
	display: flex;
	flex-wrap: wrap;
}

.m-m-fi-imageItem {
	width: auto;
	height: auto;
	background-color: rgba(238, 238, 238, 1);
	width: 140px;
	height: 100px;
	min-width: 110px !important;
	margin-right: 1%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	box-sizing: border-box;
	font-size: 14px;
	cursor: pointer;
	position: relative;
	margin-bottom: 10px;
	border-radius: 4px;
	border: dashed 1px #DCDCDC;
	overflow: hidden;
}
.m-m-fi-imageItem > .itemUrl {
	width: 100%;
	height: 100%;
}

.m-m-fi-imageItem > span {
	width: 20px;
	height: 20px;
	position: absolute;
	right: 4px;
	top: 4px;
	background-image: url("../../../../assets/icon/classroomObservation/delFile.svg");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	display: none;
	z-index: 9999;
	/* display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	box-sizing: border-box;
	padding: 2px 10px;
	color: #666666;
	font-size: 18px;
	background-color: #FFBBBB;
	cursor: pointer;
	border-radius: 100%;
	display: none; */
}

.m-m-fi-imageItem:hover > span {
	display: flex;
}

/* .m-m-fi-i-icon {
	width: 20px;
	height: 20px;
	background: url("../../../../assets/icon/classroomObservation/file.png")
		no-repeat;
	background-size: 100% 100%;
	margin-right: 5px;
} */

.m-m-fi-btn {
	width: auto;
	height: 35px;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 18px;
	font-size: 14px;
	border: solid 1px #c5c5c5;
	background-color: white;
	cursor: pointer;
	padding: 0 10px;
}

.fileList{
	width: 100%;
	position: relative;
	display: flex;
}

.fl_img{
	width: 50%;
	height: auto;
}

.fl_video{
	width: 21.8%;
	margin-left: 1.6%;
	height: auto;

}

.nephogramArea{
	width: 20%;
	height: auto;
}

.fl_nephogram{
	width: 20%;
	/* margin-left: 1.5%; */
	height: auto;
	margin-left: 1%;
	/* margin-top: -2%; */
}


.m_m_fi_progress{
	width: 100%;
	height: 100%;
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* 加载 */
	/* cursor:wait !important; */
	background-color: #00000099;
}

.m_m_fi_progress>div:nth-child(1){
	font-size: 20px;
	color: white;
}

.m_m_fi_progress>span:nth-child(2){
	font-size: 16px;
	color: #FFFFFF8C;
}

.m_m_fi_p_bar{
	width: 100%;
	height: 5px;
	position: absolute;
	bottom: 0;
	background-color: #D8E3F7;
}

.m_m_fi_p_bar>div{
	background-color: #3975CE;
	max-width: 100%;
	height: 100%;
}

.m-m-fi-nephogramItem{
	width: 140px;
	height: 100px;
	background-color: rgba(238, 238, 238, 1);
	min-width: 140px;
	min-height: 100px;
	margin-right: 1%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	box-sizing: border-box;
	font-size: 14px;
	cursor: pointer;
	position: relative;
	margin-bottom: 10px;
	border-radius: 4px;
	border: dashed 1px #DCDCDC;
	overflow: hidden;

}
.m-m-fi-nephogramItem> .itemUrl {
	width: 100%;
	height: 100%;
}

.m-m-fi-nephogramItem > span {
	width: 20px;
	height: 20px;
	position: absolute;
	right: 4px;
	top: 4px;
	background-image: url("../../../../assets/icon/classroomObservation/delFile.svg");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	display: none;
	z-index: 99999;
	/* display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	box-sizing: border-box;
	padding: 2px 10px;
	color: #666666;
	font-size: 18px;
	background-color: #FFBBBB;
	cursor: pointer;
	border-radius: 100%;
	display: none; */
}

.m-m-fi-nephogramItem:hover > span {
	display: flex;
}

.m_m_fi_videBtn{
	position: absolute;
	right: 4px;
	top: 4px;
	width:auto;
	height: 20px;
	background-size: 100% 100%;
	/* display: none; */
	z-index: 99999;
	display: flex;
}

.m_m_fi_videBtn>img{
	width: 20px;
	height: 20px;
	margin-left:10px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/baseMessage.vue